import Layout from '@layout/Index'

export const clbProductArea = [
  {
    path: '/clb-product-area',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "clb-product-area-table" */ './pages/ClbProductAreaTable.vue'),
        meta: {
          title: '查理任务区域列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "clb-product-area-form" */ './pages/ClbProductAreaForm.vue'),
        meta: {
          title: '添加查理任务区域',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "clb-product-area-form" */ './pages/ClbProductAreaForm.vue'),
        meta: {
          title: '修改查理任务区域',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "clb-product-area-detail" */ './pages/ClbProductAreaDetail.vue'),
        meta: {
          title: '查理任务区域详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/clb-product-area/clb-product-area.route.js